import React, { PropsWithChildren } from "react";
import { useAuth } from "react-oidc-context";
import { Navigate, useLocation, matchPath } from "react-router-dom";
import { Route } from "@src/routes/routes";
import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";

export const AuthGuard = ({ children }: PropsWithChildren) => {
  const { isAuthenticated, isLoading } = useAuth();

  const authContext = useSelector(
    (state: RootState) => state.yourSlice.authContext,
  );

  const connectionView = useSelector(
    (state: RootState) => state.yourSlice.connectionView,
  );

  const location = useLocation();

  if (isLoading) {
    return null;
  }

  // Skip auth check for VNC route
  const isVncRoute = matchPath(
    { path: Route.VNC, end: false },
    location.pathname,
  );

  if (!isAuthenticated && !isVncRoute) {
    return <Navigate to={Route.LOGIN} state={{ from: location }} replace />;
  }

  // user is not permitted to access the gateways page if does not have the manage-gateways permission
  if (
    location.pathname === "/gateways" &&
    authContext &&
    !authContext.permissions.includes("manage-gateways")
  ) {
    return <Navigate to={Route.MACHINES} state={{ from: location }} replace />;
  }

  // user is not allowed to navigate to /nodemanager if no source information is available
  if (
    location.pathname === "/nodemanager" &&
    (connectionView === undefined ||
      (connectionView &&
        connectionView.source &&
        !connectionView.source.source_id))
  ) {
    return <Navigate to={Route.MACHINES} state={{ from: location }} replace />;
  }

  return <>{children}</>;
};
